// RouteLink.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import LoginPage from './Pages/Login/LoginPage';
import DashboardLayout from './Layout/DashboardLayout';
import DashboardHome from './Pages/Dashboard/DashboardHome';
import AddUser from './Pages/Users/AddUser';
import DeleteUser from './Pages/Users/DeleteUser';
import AddProperty from './Pages/Property/AddProperty';
import DeleteProperty from './Pages/Property/DeleteProperty';
import PrivateRoute from './Utilities/PrivateRoute';
import Amenties from './Pages/Amenties/Amenties';
import AddAmenties from './Pages/Amenties/AddAmenties';
import Category from './Pages/Category/Category';
import AddCategory from './Pages/Category/AddCategory';
import State from './Pages/State/State';
import AddState from './Pages/State/AddState';
import Developer from './Pages/Developer/Developer';
import AddDeveloper from './Pages/Developer/AddDeveloper';
import City from './Pages/City/City';
import AddCity from './Pages/City/AddCity';
import Property from './Pages/Property/Property';
import Enquiry from './Pages/Enquiry/Enquiry';
import Banner from './Pages/Banner/Banner';
import AddBanner from './Pages/Banner/AddBanner';

// const routes = [
//   {
//     path: '/login',
//     element: <LoginPage />,
//   },
//   {
//     path: '/',
//     element: <Navigate to="/login" replace />,
//   },
//   {
//     path: '/dashboard',
//     element: <DashboardLayout />,
//     children: [
//       { index: true, element: <DashboardHome /> },
//       { path: 'add-user', element: <AddUser /> },
//       { path: 'delete-user', element: <DeleteUser /> },
//       { path: 'state', element: <StatePage /> },
//       { path: 'city', element: <CityPage /> },
//       { path: 'add-property', element: <AddProperty /> },
//       { path: 'delete-property', element: <DeleteProperty /> },
//     ],
//   },
// ];



const routes = [
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/',
    element: <Navigate to="/login" replace />,
  },
  {
    element: <PrivateRoute />, // 🛡 Wrap protected routes here
    children: [
      {
        path: '/dashboard',
        element: <DashboardLayout />,
        children: [
          { index: true, element: <DashboardHome /> },
          { path: 'amenities', element: <Amenties /> },
          { path: 'ammetitesadd', element: <AddAmenties /> },

          { path: 'developer', element: <Developer /> },
          { path: 'developeradd', element: <AddDeveloper /> },


          { path: 'category', element: <Category /> },
          { path: 'categoryadd', element: <AddCategory /> },

          { path: 'add-user', element: <AddUser /> },
          { path: 'delete-user', element: <DeleteUser /> },

          { path: 'state', element: <State /> },
          { path: 'stateadd', element: <AddState /> },

          { path: 'city', element: <City /> },
          { path: 'cityadd', element: <AddCity /> },

          { path: 'property', element: <Property /> },
          { path: 'add-property', element: <AddProperty /> },
          { path: 'delete-property', element: <DeleteProperty /> },

          { path: 'enquiry', element: <Enquiry /> },

          { path: 'banner', element: <Banner /> },
          { path: 'banneradd', element: <AddBanner /> },
        ],
      },
    ],
  },
];

export default routes;
